import React from "react";
import { useFormContext } from "react-hook-form";
import { Box, Grid2 as Grid, Grid2Props } from "@mui/material";
import { singleGridItem } from "../../fields/defaultStyles";
import renderVersionSelection from "../../../entitiesReferences/SelectionModals/VersionSelectionModal";
import SubForm from "../../fields/subForms/SubForm";
import FormEntitySelectionField from "../../fields/basic/EntitySelectionField";
import { FormSwitch } from "../../fields/basic/FormSwitch";
import { FormRichTextField } from "../../fields/basic/RichTextField";
import { useInputFullName } from "../../fields/subForms/NamePrefixContext";
import { SystemEntityCollections } from "../../../../shared/enums/shared-enums";
import { useFormHandlerContext } from "../../../../controllers/formController";
import { SystemLanguages } from "../../../../shared/enums/shared-enums";
import useVersionRefLogic from "../../../../hooks/logic/versionRefLogic";

interface FormVersionRefProps extends Grid2Props {
  name: string;
  language?: SystemLanguages | null;
  disabled?: boolean;
}

const FormVersionRef: React.FC<FormVersionRefProps> = ({
  name,
  disabled = false,
  language,
  ...grid
}) => {
  const { watch } = useFormContext();
  const { isProcessing } = useFormHandlerContext();
  const fullName = useInputFullName(name);
  const versionExist = watch(`${fullName}.version_exist`);
  const { systemLanguageType } = useVersionRefLogic(language);

  return (
    <Grid container {...singleGridItem} {...grid}>
      <SubForm name={name}>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <FormSwitch
            sx={{ flex: 1 }}
            name="version_exist"
            label="Version Exists"
            disabled={disabled || isProcessing}
          />
        </Box>
        <FormEntitySelectionField
          name="version"
          label="Version"
          entityCollection={SystemEntityCollections.VERSION}
          required={versionExist}
          hidden={!versionExist}
          placeholder={"Select a version"}
          renderEntitySelection={renderVersionSelection(
            systemLanguageType || SystemLanguages.tibetan
          )}
          disabled={disabled || isProcessing}
        />
        <FormRichTextField
          name="version_notes"
          label="Version Notes"
          hidden={versionExist}
          placeholder={"Enter version notes"}
          disabled={disabled || isProcessing}
        />
      </SubForm>
    </Grid>
  );
};

export default FormVersionRef;
